/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { LftCountdownAction, LftCountdownActionId, getIconForActionId } from '../shared';

export const LftCountdownTryCopilotActionCard: LftCountdownAction = {
    id: LftCountdownActionId.TryCopilotDialog,
    primaryContent: strings.getString('lftSidePaneTrialCountDownCopilotCardText'),
    icon: getIconForActionId(LftCountdownActionId.TryCopilotDialog),
    onClick: () => logger.logInfo('LaunchTryCopilotDialog', 'User clicked on Launch Try Copilot card.')
};
